module.exports = __webpack_public_path__ + "media/images/logo-black-f2137520d553ff13813baf82bdd34189.png";